import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import { RecomendacaoFormComponent } from 'src/app/pages/recomendacao-form/recomendacao-form.component';

@Injectable()
export class RecomendacaoGuard
  implements CanDeactivate<RecomendacaoFormComponent> {
  canDeactivate(
    component: RecomendacaoFormComponent
  ): Observable<boolean> | boolean {
    if (!component.visualizar) {
      if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    }
    else { return true; }
  }
}
